import { BaseUrl, NewUpdatedBaseUrl } from "../../BaseUrl/BaseUrl";
import { postApiWithoutAuthorization } from "../ApiMethod/ApiMethod";

export const NewsletterAPI = async (params) => {
  const url = `${BaseUrl}/InsertNewsLetter`;
  const res = await postApiWithoutAuthorization(url, params);
  return res;
};
export const AddNewsLetter = async (params) => {
  const url = `${NewUpdatedBaseUrl}/NewsLetter/AddNewsLetter`;
  const res = await postApiWithoutAuthorization(url, params);
  return res;
};
export const ContactUSApi = async (params) => {
  const url = `${BaseUrl}/ContactUS`;
  const res = await postApiWithoutAuthorization(url, params);
  return res;
};
export const AddContactUs = async (params) => {
  const url = `${NewUpdatedBaseUrl}/ContactUs/AddContactUs`;
  const res = await postApiWithoutAuthorization(url, params);
  return res;
};
